import React, { useContext } from 'react';
import { ModalType } from '@models/pages';
import { GlobalContext } from '../GlobalContext';

type Props = {
  className: string,
  globalCmsButtons: any,
  lang: string,
}

function TextAlertsButton({ globalCmsButtons, lang, className = '' }: Props) {
  const linkDetails = globalCmsButtons['Get Text Alerts'][lang];
  const globalContext = useContext(GlobalContext);

  const handleOpenSmsModal = () => {
    if (globalContext) {
      const { setShowModal } = globalContext;
      setShowModal(ModalType.SmsReminder);
    }
  };

  return (
    <button
      key={linkDetails.id}
      type="button"
      className={`px-2 py-4 leading-[20px] flex-1 font-bold basis-[45%] xl:basis-auto tracking-[0.15em] text-black text-center uppercase ${className}`}
      onClick={handleOpenSmsModal}
    >
      {linkDetails.title}
    </button>
  );
}

export default TextAlertsButton;
